import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "cc-wrap" }
const _hoisted_2 = { class: "cc-header" }
const _hoisted_3 = { class: "cc-title" }
const _hoisted_4 = {
  key: 0,
  class: "cc-grid"
}
const _hoisted_5 = { class: "cc-num" }
const _hoisted_6 = { class: "cc-badges" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "cc-more-name" }
const _hoisted_10 = { class: "cc-more-tip" }
const _hoisted_11 = {
  key: 1,
  class: "cc-year"
}
const _hoisted_12 = { class: "cc-mini-title" }
const _hoisted_13 = { class: "cc-mini-grid" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "cc-dlg-ini" }
const _hoisted_17 = { class: "cc-dlg-nume" }
const _hoisted_18 = { class: "cc-dlg-status" }
const _hoisted_19 = { class: "cc-dlg-body" }
const _hoisted_20 = { class: "cc-row" }
const _hoisted_21 = { class: "cc-val" }
const _hoisted_22 = { class: "cc-row" }
const _hoisted_23 = { class: "cc-val" }
const _hoisted_24 = { class: "cc-row" }
const _hoisted_25 = { class: "cc-val" }
const _hoisted_26 = { class: "cc-row" }
const _hoisted_27 = { class: "cc-val" }
const _hoisted_28 = { class: "cc-dlg-foot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "cc-nav",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prev && _ctx.prev(...args)))
      }, "‹"),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.mode === 'year' ? _ctx.viewY : _ctx.monthLabel), 1),
      _createElementVNode("button", {
        class: "cc-nav",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args)))
      }, "›"),
      _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"cc-legend\" data-v-3ef5d950><span class=\"cc-leg\" data-v-3ef5d950><span class=\"cc-dot\" style=\"background:#16a34a;\" data-v-3ef5d950></span>Aprobat</span><span class=\"cc-leg\" data-v-3ef5d950><span class=\"cc-dot\" style=\"background:#ea580c;\" data-v-3ef5d950></span>În așteptare</span><span class=\"cc-leg\" data-v-3ef5d950><span class=\"cc-dot\" style=\"background:#e11d48;\" data-v-3ef5d950></span>Liber oficial</span></div>", 1)),
      _createElementVNode("button", {
        class: "cc-today",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToday && _ctx.goToday(...args)))
      }, "Azi")
    ]),
    (_ctx.mode !== 'year')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dows, (d) => {
            return (_openBlock(), _createElementBlock("div", {
              key: d,
              class: "cc-dow"
            }, _toDisplayString(d), 1))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cells, (cell, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: _normalizeClass(["cc-cell", { 'cc-out': !cell.inMonth, 'cc-today': cell.today, 'cc-weekend': cell.weekend, 'cc-holiday': cell.holiday }])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(cell.day) + " ", 1),
                (cell.holiday)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      location: "top",
                      text: cell.holidayNume
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("span", _mergeProps({ ref_for: true }, props, { class: "cc-hol-dot" }), "●", 16)
                      ]),
                      _: 1
                    }, 8, ["text"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell.badges.slice(0, _ctx.maxBadges), (b, bi) => {
                  return (_openBlock(), _createBlock(_component_v_tooltip, {
                    key: bi,
                    location: "top"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createElementVNode("span", _mergeProps({ ref_for: true }, props, {
                        class: "cc-badge",
                        style: { background: b.color },
                        onClick: ($event: any) => (_ctx.openDetalii(b))
                      }), _toDisplayString(b.initiale), 17, _hoisted_7)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(b.nume) + " — " + _toDisplayString(b.tip), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (cell.badges.length > _ctx.maxBadges)
                  ? (_openBlock(), _createBlock(_component_v_menu, {
                      key: 0,
                      location: "top",
                      "close-on-content-click": false
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("span", _mergeProps({ ref_for: true }, props, { class: "cc-more" }), "+" + _toDisplayString(cell.badges.length - _ctx.maxBadges), 17)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                          class: "pa-2",
                          "max-width": "280"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell.badges, (b, bi) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: bi,
                                class: "cc-more-item",
                                onClick: ($event: any) => (_ctx.openDetalii(b))
                              }, [
                                _createElementVNode("span", {
                                  class: "cc-badge cc-badge-sm",
                                  style: _normalizeStyle({ background: b.color })
                                }, _toDisplayString(b.initiale), 5),
                                _createElementVNode("span", _hoisted_9, _toDisplayString(b.nume), 1),
                                _createElementVNode("span", _hoisted_10, _toDisplayString(b.tip), 1)
                              ], 8, _hoisted_8))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.luniAn, (mo) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "cc-mini",
              key: mo.luna
            }, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(mo.nume), 1),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dows, (d) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'd'+d,
                    class: "cc-mini-dow"
                  }, _toDisplayString(d), 1))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mo.cells, (cell, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                    (cell.inMonth && (cell.badges.length || cell.holiday))
                      ? (_openBlock(), _createBlock(_component_v_tooltip, {
                          key: 0,
                          location: "top"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createElementVNode("span", _mergeProps({ ref_for: true }, props, {
                              class: ["cc-mini-cell", { hol: cell.holiday && !cell.badges.length, today: cell.today }],
                              style: cell.badges.length ? { background: cell.badges[0].color, color: '#fff', borderColor: cell.badges[0].color } : {},
                              onClick: ($event: any) => (cell.badges.length ? _ctx.openDetalii(cell.badges[0]) : null)
                            }), _toDisplayString(cell.day), 17, _hoisted_14)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              (cell.holiday)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, "● " + _toDisplayString(cell.holidayNume), 1))
                                : _createCommentVNode("", true),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell.badges, (b, bi) => {
                                return (_openBlock(), _createElementBlock("div", { key: bi }, _toDisplayString(b.nume) + " — " + _toDisplayString(b.tip), 1))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(["cc-mini-cell", { out: !cell.inMonth, today: cell.today }])
                        }, _toDisplayString(cell.inMonth ? cell.day : ''), 3))
                  ], 64))
                }), 128))
              ])
            ]))
          }), 128))
        ])),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogDetalii,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogDetalii) = $event)),
      "max-width": "420"
    }, {
      default: _withCtx(() => [
        (_ctx.sel)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              rounded: "xl",
              class: "cc-dlg"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "cc-dlg-head",
                  style: _normalizeStyle({ background: _ctx.sel.color })
                }, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.sel.initiale), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.sel.nume), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.sel.stare === '1' ? '✓ Aprobat' : '⏳ În așteptare'), 1)
                  ])
                ], 4),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "cc-lbl" }, "Tip concediu", -1)),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.sel.tip), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "cc-lbl" }, "De la", -1)),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.fmt(_ctx.sel.start)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "cc-lbl" }, "Până la", -1)),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.fmt(_ctx.sel.end)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "cc-lbl" }, "Durată", -1)),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.nrZile(_ctx.sel)) + " " + _toDisplayString(_ctx.nrZile(_ctx.sel) === 1 ? 'zi' : 'zile'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_v_btn, {
                    variant: "tonal",
                    color: "grey-darken-1",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogDetalii = false))
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Închide", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}